export const factsArray = [
  [
    'A CREATIVE “CITY WITHIN A CITY” IN THE ARTS DISTRICT',
    '1920S HISTORIC BUILDINGS',
    '32-ACRE INTIMATE, WALKABLE DISTRICT',
    'EXPANSIVE WINDOWS, ABUNDANT NATURAL LIGHT',
    'UNPARALLELED VIEWS OF DTLA SKYLINE',
  ],
  [
    'ADJACENT TO FUTURE ARTS DISTRICT SOUTH METRO STATION',
    '4 PER 1,000 SF PARKING, 4,000 STALL PARKING STRUCTURE',
    'CONTINUOUS MORNING AND EVENING SHUTTLES TO AND FROM UNION STATION AND 7TH STREET METRO STATION',
    'METRO BIKE STATION AND INDOOR BIKE ROOM',
  ],
  [
    'FLEXIBLE FLOOR PLATES 3,200 UP TO 400,000 SF WITH THE ABILITY TO GROW',
    'PREBUILT MOVE-IN READY SPACES FROM 3,600 – 65,000 SF',
    'OVERSIZED ELEVATORS',
    'FULLY ACCESSIBLE, DOUBLE-WIDE MODERNIZED STAIRWELLS',
    'HVAC SERVICED BY TENANT CONTROLLED VRF SYSTEMS (MERV 13 OPTIONAL)',
    'NET NEUTRAL FIBER CAPABILITIES TO ACCOMMODATE ANY PROVIDER',
    '24 / 7 ON-SITE SECURITY',
  ],
  [
    'EXCLUSIVE ATHLETIC CLUB WITH WELLNESS PROGRAMS AND PERSONAL TRAINING',
    '7 RESTAURANTS FEATURING PLENTIFUL OUTDOOR DINING AND TAKE OUT OPTIONS',
    '35 RETAILERS',
    'ART AND MUSIC ACTIVATIONS',
    'PRIVATE EVENT SPACES',
    'WEISER FAMILY FARMS STAND, WINE & SPIRITS TASTING, ARTISAN WORKSHOPS',
  ],
  [
    'CO-TENANTS INCLUDE: ADIDAS, FASHIONPHILE, CONDE NAST, MAJORDOMO STUDIO, PROTEUS, DAY ONE AGENCY, MARSH MCLENNAN AGENCY, REVOLVE, WILSON AND MORE',
    'AROUND THE NEIGHBORHOOD: HAUSER & WIRTH, ART SHARE L.A., DOVER STREET MARKET, WARNER MUSIC GROUP, HONEY, WEWORK, BESTIA, ROLLING GREENS, ANGEL CITY BREWERY',
  ],
];
